// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2439":"a52a5a17","3763":"a52a5a17","4528":"844e1dbb"}[chunkId] + ".chunk.css";
};